import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { IntegrationType } from '../../types/integration-type';
import { IntegrationInformationWebController } from '../controller/IntegrationInformationWebController';

export class IntegrationInformationWebComponent extends BaseWebComponentElement {
  public controller: IntegrationInformationWebController;
  private integrationType: IntegrationType;
  private userConfigurable: Boolean;
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: IntegrationInformationWebController,
    });
  }

  public setIntegrationType(integrationType: IntegrationType) {
    this.integrationType = integrationType;
    this.controller.view.addIntegrationSpecificRequirements(integrationType);
  }

  public setUserConfigurable(userConfigurable: Boolean) {
    this.userConfigurable = userConfigurable;
  }

  public getIntegrationType(): IntegrationType {
    return this.integrationType;
  }

  public getUserConfigurable(): Boolean {
    return this.userConfigurable;
  }
}
